// import React, { useState } from 'react';

// const HomeSliderOne = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const slidesToShow = 4;
//   const slides = [
//     { image: './images/collections/ss1.jpg' },
//     { image: './images/collections/ss2.jpg' },
//     { image: './images/collections/ss3.jpg' },
//     { image: './images/collections/ss4.jpg' },
//     { image: './images/collections/ss5.jpg' },
//     { image: './images/collections/ss1.jpg' },
//     { image: './images/collections/ss2.jpg' },
//     { image: './images/collections/ss3.jpg' }
//   ];

//   const totalSlides = slides.length;

//   const moveSlider = (direction) => {
//     let newIndex = currentIndex + direction * slidesToShow;

//     // Ensure the index stays within bounds
//     if (newIndex < 0) newIndex = 0;
//     if (newIndex > totalSlides - slidesToShow) newIndex = totalSlides - slidesToShow;

//     setCurrentIndex(newIndex);
//   };

//   const offset = -(currentIndex * (100 / slidesToShow));

//   return (
    
//     <div className="slider-container">
//       <button className="slider-btn prev-btn" onClick={() => moveSlider(-1)}>&#10094;</button>
//       <div className="slider-track" style={{ transform: `translateX(${offset}%)` }}>
//         {slides.map((product, index) => (
//           <div className="slide" key={index}>
//             <img src={product.image} alt={product.name} className="slide-image" />
//             <div>{product.name}</div>
//           </div>
//         ))}
//       </div>
//       <button className="slider-btn next-btn" onClick={() => moveSlider(1)}>&#10095;</button>
//     </div>
//   );
// };

// export default HomeSliderOne;



// import React, { useState, useEffect } from 'react';

// const HomeSliderOne = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [slidesToShow, setSlidesToShow] = useState(1); // Default to mobile view settings

//   const slides = [
//     { image: './images/collections/ss1.jpg' },
//     { image: './images/collections/ss2.jpg' },
//     { image: './images/collections/ss3.jpg' },
//     { image: './images/collections/ss4.jpg' },
//     { image: './images/collections/ss5.jpg' },
//     { image: './images/collections/ss1.jpg' },
//     { image: './images/collections/ss2.jpg' },
//     { image: './images/collections/ss3.jpg' }
//   ];

//   const totalSlides = slides.length;

//   useEffect(() => {
//     // Adjust the number of slides shown based on screen width
//     const updateSlidesToShow = () => {
//       if (window.innerWidth < 768) {
//         setSlidesToShow(1); // Mobile view shows 1 slide
//       } else {
//         setSlidesToShow(4); // Desktop view shows 3 slides
//       }
//     };

//     updateSlidesToShow(); // Initial check
//     window.addEventListener('resize', updateSlidesToShow); // Adjust on resize

//     return () => window.removeEventListener('resize', updateSlidesToShow);
//   }, []);

//   const moveSlider = (direction) => {
//     let newIndex = currentIndex + direction;

//     // Prevent moving past the first or last slide
//     if (newIndex < 0) newIndex = 0;
//     if (newIndex > totalSlides - slidesToShow) newIndex = totalSlides - slidesToShow;

//     setCurrentIndex(newIndex);
//   };

//   const offset = -(currentIndex * (100 / slidesToShow));

//   return (
//     <div className="slider-container">
//       <button
//         className="slider-btn prev-btn"
//         onClick={() => moveSlider(-1)}
//         disabled={currentIndex === 0} // Disable button at the start
//       >
//         &#10094;
//       </button>
//       <div className="slider-track" style={{ transform: `translateX(${offset}%)` }}>
//         {slides.map((product, index) => (
//           <div className="slide" key={index} style={{ width: `${100 / slidesToShow}%` }}>
//             <img src={product.image} alt={`Slide ${index}`} className="slide-image" />
//           </div>
//         ))}
//       </div>
//       <button
//         className="slider-btn next-btn"
//         onClick={() => moveSlider(1)}
//         disabled={currentIndex >= totalSlides - slidesToShow} // Disable button at the end
//       >
//         &#10095;
//       </button>
//     </div>
//   );
// };

// export default HomeSliderOne;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
// import './HomeSliderOne.css';
// const HomeSliderOne = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [slidesToShow, setSlidesToShow] = useState(1); // Default to mobile view settings

//   const navigate = useNavigate(); // Initialize navigate hook

//   const slides = [
//     { image: './images/collections/ss1.jpg', styleName: 'Jodhpuri Suits' },
//     { image: './images/collections/ss2.jpg', styleName: 'Suits & Tuxedos' },
//     { image: './images/collections/ss3.jpg', styleName: 'Blazers' },
//     { image: './images/collections/ss4.jpg', styleName: 'Ethnic Jackets & Kurta Pyjama' },
//     { image: './images/collections/ss5.jpg', styleName: 'Indowestern & Sherwani' },
//     { image: './images/collections/ss1.jpg', styleName: 'Jodhpuri Suits' },
//     { image: './images/collections/ss2.jpg', styleName: 'Suits & Tuxedos' },
//     { image: './images/collections/ss3.jpg', styleName: 'Blazers' }
//   ];

//   const totalSlides = slides.length;

//   useEffect(() => {
//     // Adjust the number of slides shown based on screen width
//     const updateSlidesToShow = () => {
//       if (window.innerWidth < 450) {
//         setSlidesToShow(1); // Mobile view shows 1 slide
//       } else {
//         setSlidesToShow(4); // Desktop view shows 4 slides
//       }
//     };

//     updateSlidesToShow(); // Initial check
//     window.addEventListener('resize', updateSlidesToShow); // Adjust on resize

//     return () => window.removeEventListener('resize', updateSlidesToShow);
//   }, []);

//   const moveSlider = (direction) => {
//     let newIndex = currentIndex + direction;

//     // Prevent moving past the first or last slide
//     if (newIndex < 0) newIndex = 0;
//     if (newIndex > totalSlides - slidesToShow) newIndex = totalSlides - slidesToShow;

//     setCurrentIndex(newIndex);
//   };

//   const offset = -((currentIndex * (100 / slidesToShow)));

//   // Function to handle clicking on a slide
//   const handleSlideClick = (style) => {
//     // Navigate to the products page, passing the selected style as state
//     navigate("/products", { state: { selectedStyle: style } });
//   };

//   return (
//     <div className="slider-container">
//       <button
//         className="slider-btn prev-btn"
//         onClick={() => moveSlider(-1)}
//         disabled={currentIndex === 0} // Disable button at the start
//       >
//         &#10094;
//       </button>
//       <div className="slider-track" style={{ transform: `translateX(${offset}%)` }}>
//         {slides.map((product, index) => (
//           <div className="slide" key={index} style={{ width: `${100 / slidesToShow}%` }}>
//             {/* Add click handler to the image */}
//             <div onClick={() => handleSlideClick(product.styleName)}>
//               <img src={product.image} alt={`Slide ${index}`} className="slide-image" />
//             </div>
//           </div>
//         ))}
//       </div>
//       <button
//         className="slider-btn next-btn"
//         onClick={() => moveSlider(1)}
//         disabled={currentIndex >= totalSlides - slidesToShow} // Disable button at the end
//       >
//         &#10095;
//       </button>
//     </div>
//   );
// };

// export default HomeSliderOne;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import './HomeSliderOne.css';

const HomeSliderOne = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(1); // Default to mobile view settings
  const [isMobile, setIsMobile] = useState(window.innerWidth < 450); // Track if it's mobile view

  const navigate = useNavigate(); // Initialize navigate hook
  const handleRent = (productId) => {
    console.log("Navigating with productId:", productId); // Debugging step
    navigate('/productpreview', { state: { productId } }); // Pass productId to preview page
  };
  const slides = [
    { image: './images/collections/ss7.jpg', styleName: 'Jodhpuri Suits' ,id:"678a1c7bf70a6e0d44ffd9fa"},
    { image: './images/collections/ss8.jpg', styleName: 'Suits & Tuxedos',id:"678a1c7bf70a6e0d44ffd9fa" },
    { image: './images/collections/ss9.jpg', styleName: 'Blazers',id:"678a198ff70a6e0d44ffd261" },
    { image: './images/collections/ss10.jpg', styleName: 'Ethnic Jackets & Kurta Pyjama',id:"678a27aef70a6e0d44001203" },
    { image: './images/collections/ss11.jpg', styleName: 'Indowestern & Sherwani',id:"678a29c1f70a6e0d440021d0" },
    { image: './images/collections/ss12.jpg', styleName: 'Jodhpuri Suits',id:"678a1666f70a6e0d44ffce4a" },
    { image: './images/collections/ss13.jpg', styleName: 'Suits & Tuxedos',id:"678a14c1f70a6e0d44ffcd8d" },
    { image: './images/collections/ss14.jpg', styleName: 'Blazers',id:"678a1f2ff70a6e0d44ffe06f" }
  ];

  const totalSlides = slides.length;

  useEffect(() => {
    // Adjust the view based on screen width (for mobile view vs desktop view)
    const updateIsMobile = () => {
      if (window.innerWidth < 450) {
        setSlidesToShow(1); // Mobile view shows 1 slide
        setIsMobile(true); // Set to mobile view
      } else {
        setSlidesToShow(4); // Desktop view shows 4 slides
        setIsMobile(false); // Set to desktop view
      }
    };

    updateIsMobile(); // Initial check
    window.addEventListener('resize', updateIsMobile); // Adjust on resize

    return () => window.removeEventListener('resize', updateIsMobile);
  }, []);

  const moveSlider = (direction) => {
    let newIndex = currentIndex + direction;

    // Prevent moving past the first or last slide
    if (newIndex < 0) newIndex = 0;
    if (newIndex > totalSlides - slidesToShow) newIndex = totalSlides - slidesToShow;

    setCurrentIndex(newIndex);
  };

  // Apply 3% increase on mobile view offset
  const offset = isMobile
    ? -((currentIndex * (100 / slidesToShow)) * 1.03)  // Mobile view with 3% increase
    : -(currentIndex * (100 / slidesToShow));          // Desktop view with normal offset

  // Function to handle clicking on a slide
  // const handleSlideClick = (style) => {
  //   // Navigate to the products page, passing the selected style as state
  //   navigate("/products", { state: { selectedStyle: style } });
  // };

  return (
    <div className="slider-container">
      <button
        className="slider-btn prev-btn"
        onClick={() => moveSlider(-1)}
        disabled={currentIndex === 0} // Disable button at the start
      >
        &#10094;
      </button>
      <div className="slider-track" style={{ transform: `translateX(${offset}%)` }}>
        {slides.map((product, index) => (
          <div className="slide" key={index} style={{ width: `${100 / slidesToShow}%` }}> {/* Adjust width based on slidesToShow */}
            {/* Add click handler to the image */}
            <div >
              <img src={product.image} alt={`Slide ${index}`} className="slide-image" onClick={() => handleRent(product.id)} />
            </div>
          </div>
        ))}
      </div>
      <button
        className="slider-btn next-btn"
        onClick={() => moveSlider(1)}
        disabled={currentIndex >= totalSlides - slidesToShow} // Disable button at the end
      >
        &#10095;
      </button>
    </div>
  );
};

export default HomeSliderOne;
